module.exports = __webpack_public_path__ + "img/ForExpired.fda076bd.svg";